
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as testaxQ_kDv67moLKLK3ThUkdXvcePW6ePvW_45RUQV6TUs3gMeta } from "/vercel/path1/pages/test.vue?macro=true";
import { default as dropsPOaXD3b_XZ1F9mvylcNabMfUffwXSFTRqUEjIPXrH8kMeta } from "/vercel/path1/pages/drops.vue?macro=true";
import { default as eventeAGhtB3O7WMOKjcLOyobPtlWodsgC_p5zBZm750PLkgMeta } from "/vercel/path1/pages/event.vue?macro=true";
import { default as geshawtYgO1pwuTu37L48sbfqrv_KyNxWO5vWEpdTZr4Wen0Meta } from "/vercel/path1/pages/gesha.vue?macro=true";
import { default as indexqYfu2AWB8IxcjYRpy3wfXaf7X1a5C3aGnOp5CZNI1c4Meta } from "/vercel/path1/pages/index.vue?macro=true";
import { default as signinqL3LpZV8og9i74n71IEQCiGzpnDMHQhJvhAd__45yN73IMeta } from "/vercel/path1/pages/signin.vue?macro=true";
import { default as patriotYi3VFot_454XXYIJ83hc0_45s2HgulStxlyaklnkYUbGQCIMeta } from "/vercel/path1/pages/patriot.vue?macro=true";
import { default as rainbowSnnC1qhfTkokP_GO4TbJOoCaJzyBfLgMYoBv7YZam8UMeta } from "/vercel/path1/pages/rainbow.vue?macro=true";
import { default as fit_45foamgeeesMP1svH_45wTvTmntFPtV0wvRqehftWPCrOTKGwhMMeta } from "/vercel/path1/pages/fit-foam.vue?macro=true";
import { default as sipsclubfdf6dfKsmWWn3Z5ZAlM4gS7clAxkM2CAuuE_rjX5LSoMeta } from "/vercel/path1/pages/sipsclub.vue?macro=true";
import { default as swatchesyMR_45FPhwS6E43X7BI59URHglSxu9ER263qopAwDhz8YMeta } from "/vercel/path1/pages/swatches.vue?macro=true";
import { default as _91_46_46_46slug_93ocv3_45shkNEiNcsOysv7xERpemlyxNYnavSfSMuayYKQMeta } from "/vercel/path1/pages/[...slug].vue?macro=true";
import { default as cajamarcaD8BWGntt8_Kx8mqvGEU52NMT9RrqqByFK1JWZ8aM1JkMeta } from "/vercel/path1/pages/cajamarca.vue?macro=true";
import { default as indonesia71aLTxSeoF74ILLniyRfzWIVeGERbGLNKTjG_45d5oQ_458Meta } from "/vercel/path1/pages/indonesia.vue?macro=true";
import { default as coffee_45news7_45tnI2UjirIzJDQg0loaGRkBwXoUC_kwrKuiyoB7VaIMeta } from "/vercel/path1/pages/coffee-news.vue?macro=true";
import { default as mitocreamer3jznDZoXpLOEd9LfOjgd2iFhMajISf6YdiXw6wBR9dcMeta } from "/vercel/path1/pages/mitocreamer.vue?macro=true";
import { default as cognition_45newWmFgPV8uZDMRHYFOVJDhfB81Hk30iRvIIWb6K2tIK80Meta } from "/vercel/path1/pages/cognition-new.vue?macro=true";
import { default as frosted_45cookieI6edZp9oF9azrmaLvGeTQKLSduV9NFqMwszZzfYkikUMeta } from "/vercel/path1/pages/frosted-cookie.vue?macro=true";
import { default as lifeboostlatte1hYWkTOKxihYve8Susvo6dp3oyPVpZu_45Yie4DuV_7azQMeta } from "/vercel/path1/pages/lifeboostlatte1.vue?macro=true";
import { default as coffee_45and_45liverSVahlMWD9HRrUHlDtdRJi_Njc4g5ZYr_Hjjf4f5zjM8Meta } from "/vercel/path1/pages/coffee-and-liver.vue?macro=true";
import { default as healthy_45coffee_4525Y_L3lDxA6oAuIkktkQLKtWxMplm8DHQpixPbLvF1Y6IMeta } from "/vercel/path1/pages/healthy-coffee-25.vue?macro=true";
import { default as mushroomspecial_45beiDldTwVu3C8A7SCvW84HGa4P9eg_960VGK50MoYU4ycMeta } from "/vercel/path1/pages/mushroomspecial-be.vue?macro=true";
import { default as real_45mushroom_45coffeeyJlhpvhh37tak7YMR5cbqVZrJHVcHdsS6ZrEa_3YdcAMeta } from "/vercel/path1/pages/real-mushroom-coffee.vue?macro=true";
import { default as strawberry_45lifeboocha9wbtN8WTfgSkoQOo2TjiN5h4DBW0wFN01jws77RHQgcMeta } from "/vercel/path1/pages/strawberry-lifeboocha.vue?macro=true";
import { default as real_45mushroom_45coffee_45goq4nl3n_jBCI7wtq94ZWtBguwg_F4mgKWxxa0nhS2n7YMeta } from "/vercel/path1/pages/real-mushroom-coffee-go.vue?macro=true";
export default [
  {
    name: "test",
    path: "/test",
    component: () => import("/vercel/path1/pages/test.vue")
  },
  {
    name: "drops",
    path: "/drops",
    component: () => import("/vercel/path1/pages/drops.vue")
  },
  {
    name: "event",
    path: "/event",
    component: () => import("/vercel/path1/pages/event.vue")
  },
  {
    name: "gesha",
    path: "/gesha",
    component: () => import("/vercel/path1/pages/gesha.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path1/pages/index.vue")
  },
  {
    name: "signin",
    path: "/signin",
    component: () => import("/vercel/path1/pages/signin.vue")
  },
  {
    name: "patriot",
    path: "/patriot",
    component: () => import("/vercel/path1/pages/patriot.vue")
  },
  {
    name: "rainbow",
    path: "/rainbow",
    component: () => import("/vercel/path1/pages/rainbow.vue")
  },
  {
    name: "fit-foam",
    path: "/fit-foam",
    component: () => import("/vercel/path1/pages/fit-foam.vue")
  },
  {
    name: "sipsclub",
    path: "/sipsclub",
    component: () => import("/vercel/path1/pages/sipsclub.vue")
  },
  {
    name: "swatches",
    path: "/swatches",
    component: () => import("/vercel/path1/pages/swatches.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/vercel/path1/pages/[...slug].vue")
  },
  {
    name: "cajamarca",
    path: "/cajamarca",
    component: () => import("/vercel/path1/pages/cajamarca.vue")
  },
  {
    name: "indonesia",
    path: "/indonesia",
    component: () => import("/vercel/path1/pages/indonesia.vue")
  },
  {
    name: "coffee-news",
    path: "/coffee-news",
    component: () => import("/vercel/path1/pages/coffee-news.vue")
  },
  {
    name: "mitocreamer",
    path: "/mitocreamer",
    component: () => import("/vercel/path1/pages/mitocreamer.vue")
  },
  {
    name: "cognition-new",
    path: "/cognition-new",
    component: () => import("/vercel/path1/pages/cognition-new.vue")
  },
  {
    name: "frosted-cookie",
    path: "/frosted-cookie",
    component: () => import("/vercel/path1/pages/frosted-cookie.vue")
  },
  {
    name: "lifeboostlatte1",
    path: "/lifeboostlatte1",
    component: () => import("/vercel/path1/pages/lifeboostlatte1.vue")
  },
  {
    name: "coffee-and-liver",
    path: "/coffee-and-liver",
    component: () => import("/vercel/path1/pages/coffee-and-liver.vue")
  },
  {
    name: "healthy-coffee-25",
    path: "/healthy-coffee-25",
    component: () => import("/vercel/path1/pages/healthy-coffee-25.vue")
  },
  {
    name: "mushroomspecial-be",
    path: "/mushroomspecial-be",
    component: () => import("/vercel/path1/pages/mushroomspecial-be.vue")
  },
  {
    name: "real-mushroom-coffee",
    path: "/real-mushroom-coffee",
    component: () => import("/vercel/path1/pages/real-mushroom-coffee.vue")
  },
  {
    name: "strawberry-lifeboocha",
    path: "/strawberry-lifeboocha",
    component: () => import("/vercel/path1/pages/strawberry-lifeboocha.vue")
  },
  {
    name: "real-mushroom-coffee-go",
    path: "/real-mushroom-coffee-go",
    component: () => import("/vercel/path1/pages/real-mushroom-coffee-go.vue")
  }
]